import React, { useState, useEffect } from "react";
import { Container, Box, Typography } from "@mui/material";
import SuggestListFilter from "../SuggestListFilter";
import SuggestListTable from "../SuggestListTable";
import useSuggestionsIndex from "../../../shared/hooks/useSuggestionsIndex";

const SuggestListPage = () => {
  // 表示対象のページ種別（複数選択可）
  const [pageTypes, setPageTypes] = useState([]);

  // 並び順（優先度 or 作成日）
  const [sort, setSort] = useState("priority");

  // 一覧取得
  const base = useSuggestionsIndex({
    mode: "company",
    initialPageType: "",
  });

  // 画面表示用のローカルstate（即反映用）
  const [items, setItems] = useState([]);

  // refetch結果が来たらローカルにも同期
  useEffect(() => {
    setItems(base.suggestions ?? []);
  }, [base.suggestions]);

  return (
    <Container maxWidth="md" sx={{ position: "relative", mt: 2, mb: 10 }}>
      {/* ページタイトル */}
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6" fontWeight="bold">
          サジェスト一覧
        </Typography>
      </Box>

      {/* フィルター・並び順切り替え */}
      <Box
        sx={{
          position: "sticky",
          top: 55,
          zIndex: 10,
          backgroundColor: "#F4F7FA",
          py: 1,
        }}
      >
        <SuggestListFilter
          pageTypes={pageTypes}
          onChangePageTypes={setPageTypes}
          sort={sort}
          onChangeSort={setSort}
        />
      </Box>

      {/* サジェスト一覧テーブル */}
      <SuggestListTable
        pageTypes={pageTypes}
        sort={sort}
        items={items}
        setItems={setItems}
        onRefetch={base.refetch}
      />
    </Container>
  );
};

export default SuggestListPage;
